import React, {useEffect, useRef, useState} from 'react';
import DatePicker from 'react-multi-date-picker';
import DatePanel from 'react-multi-date-picker/plugins/date_panel';
import '../../assets/css/demo.css'; // keep your styling here

const MultipleDatePickerComponent = ({
  showDate,
  setDate,
  min,
  max,
  validated,
  disabled = false,
}) => {
  const [focus, setFocus] = useState(true);
  const inputRef = useRef(null);

  const months = [
    ['Janvier', 'jan'],
    ['Février', 'fév'],
    ['Mars', 'mar'],
    ['Avril', 'avr'],
    ['Mai', 'mai'],
    ['Juin', 'jui'],
    ['Juillet', 'jul'],
    ['Août', 'aoû'],
    ['Septembre', 'sep'],
    ['Octobre', 'oct'],
    ['Novembre', 'nov'],
    ['Décembre', 'déc'],
  ];

  const weekDays = [
    ['Dim', 'D'],
    ['Lun', 'L'],
    ['Mar', 'M'],
    ['Mer', 'M'],
    ['Jeu', 'J'],
    ['Ven', 'V'],
    ['Sam', 'S'],
  ];

  useEffect(() => {
    if (focus && inputRef?.current) {
      inputRef.current.focus();
    }
  }, [focus]);

  return (
    <DatePicker
      multiple
      range
      showOtherDays
      inputClass="custom-input"
      placeholder="dd/mm/yyyy"
      value={showDate}
      onChange={setDate}
      months={months}
      weekDays={weekDays}
      disabled={disabled}
      minDate={min ? new Date(min) : undefined}
      maxDate={max ? new Date(max) : undefined}
      ref={inputRef}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      plugins={[
        // eslint-disable-next-line react/jsx-key
        <DatePanel />,
      ]}
    />

  );
};

export default MultipleDatePickerComponent;
